


















































import { Component, Vue, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'

@Component

export default class ComponentVeracruzReservaUti extends Vue {
  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getErrorMessage() {
    return this.getSolicitacaoStore.errorMessage
  }
}
